import styled from 'styled-components';
import { Tabs } from 'antd';
import { COLORS } from '../../constants/colors';

export const InboxContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 0; /* Important for flex children to properly shrink */
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const ThreadListPanel = styled.div`
  width: 280px;
  min-width: 280px;
  border-right: 1px solid ${COLORS.border};
  display: flex;
  flex-direction: column;
  background: #fafafa;
  height: 100%;
  
  @media (max-width: 768px) {
    width: 100%;
    min-width: 100%;
    display: ${props => props.showConversation ? 'none' : 'flex'};
  }
`;

export const ThreadListHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${COLORS.border};
  background: white;
  
  h2 {
    margin: 0 0 12px 0;
    font-size: 20px;
    font-weight: 600;
    color: ${COLORS.textDark};
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid ${COLORS.border};
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
  
  &:focus {
    border-color: ${COLORS.$primaryBlue};
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
  }
  
  &::placeholder {
    color: ${COLORS.textLight};
  }
`;

export const ThreadList = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const ThreadItem = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  border-bottom: 1px solid ${COLORS.border};
  background: ${props => props.active ? 'white' : 'transparent'};
  border-left: 3px solid ${props => props.active ? COLORS.$primaryBlue : 'transparent'};
  transition: all 0.2s ease;
  
  &:hover {
    background: white;
  }
`;

export const ThreadAvatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${props => props.color || COLORS.$primaryBlue};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 16px;
  margin-right: 14px;
  flex-shrink: 0;
`;

export const ThreadInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ThreadName = styled.div`
  font-weight: 600;
  color: ${COLORS.textDark};
  font-size: 14px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  .name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .time {
    font-size: 12px;
    color: ${COLORS.textLight};
    font-weight: 400;
    flex-shrink: 0;
    margin-left: 8px;
  }
`;

export const ThreadPreview = styled.div`
  font-size: 13px;
  color: ${COLORS.textMedium};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  .preview-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const UnreadBadge = styled.span`
  background: ${COLORS.$mainRed};
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  flex-shrink: 0;
  margin-left: 8px;
`;

export const ConversationPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  height: 100%;
  
  @media (max-width: 768px) {
    display: ${props => props.showConversation ? 'flex' : 'none'};
  }
`;

export const ConversationHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid ${COLORS.border};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
`;

export const ConversationInfo = styled.div`
  display: flex;
  align-items: center;
  
  .back-button {
    display: none;
    margin-right: 12px;
    padding: 8px;
    border: none;
    background: none;
    cursor: pointer;
    color: ${COLORS.textMedium};
    font-size: 18px;
    
    @media (max-width: 768px) {
      display: block;
    }
  }
  
  .contact-name {
    font-size: 16px;
    font-weight: 600;
    color: ${COLORS.textDark};
  }
  
  .contact-phone {
    font-size: 13px;
    color: ${COLORS.textMedium};
    margin-top: 2px;
  }
`;

export const ConversationActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const MessageList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #f8f9fa;
`;

export const MessageBubble = styled.div`
  max-width: 70%;
  padding: 12px 16px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.5;
  align-self: ${props => props.outbound ? 'flex-end' : 'flex-start'};
  background: ${props => props.outbound ? COLORS.$primaryBlue : 'white'};
  color: ${props => props.outbound ? 'white' : COLORS.textDark};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  
  .message-time {
    font-size: 11px;
    color: ${props => props.outbound ? 'rgba(255, 255, 255, 0.7)' : COLORS.textLight};
    margin-top: 6px;
    text-align: ${props => props.outbound ? 'right' : 'left'};
  }
`;

export const MessageInputArea = styled.div`
  padding: 16px 24px;
  border-top: 1px solid ${COLORS.border};
  background: white;
  display: flex;
  align-items: flex-end;
  gap: 12px;
`;

export const MessageTextarea = styled.textarea`
  flex: 1;
  padding: 12px 16px;
  border: 1px solid ${COLORS.border};
  border-radius: 24px;
  font-size: 14px;
  resize: none;
  min-height: 44px;
  max-height: 120px;
  outline: none;
  font-family: inherit;
  transition: all 0.2s ease;
  
  &:focus {
    border-color: ${COLORS.$primaryBlue};
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
  }
  
  &::placeholder {
    color: ${COLORS.textLight};
  }
`;

export const SendButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: ${COLORS.$primaryBlue};
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  
  &:hover {
    background: #0056b3;
    transform: scale(1.05);
  }
  
  &:disabled {
    background: ${COLORS.border};
    cursor: not-allowed;
    transform: none;
  }
`;

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${COLORS.textLight};
  
  .icon {
    font-size: 64px;
    margin-bottom: 16px;
    opacity: 0.5;
  }
  
  .title {
    font-size: 18px;
    font-weight: 600;
    color: ${COLORS.textMedium};
    margin-bottom: 8px;
  }
  
  .subtitle {
    font-size: 14px;
  }
`;

export const LoadingSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: ${COLORS.textLight};
`;

export const TabBar = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid ${COLORS.border};
  background: #fafafa;
`;

export const TabItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  background: ${props => props.active ? 'white' : 'transparent'};
  border: none;
  border-bottom: 2px solid ${props => props.active ? COLORS.$primaryBlue : 'transparent'};
  color: ${props => props.active ? COLORS.$primaryBlue : COLORS.textMedium};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    color: ${COLORS.$primaryBlue};
    background: white;
  }
  
  svg {
    font-size: 14px;
  }
`;

export const TemplateList = styled.div`
  padding: 16px;
  overflow-y: auto;
  flex: 1;
`;

export const TemplateCard = styled.div`
  padding: 14px 16px;
  background: white;
  border: 1px solid ${COLORS.border};
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: ${COLORS.$primaryBlue};
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
  }
  
  .template-name {
    font-weight: 600;
    color: ${COLORS.textDark};
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .template-preview {
    font-size: 13px;
    color: ${COLORS.textMedium};
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  .template-category {
    font-size: 11px;
    color: ${COLORS.$primaryBlue};
    background: rgba(24, 144, 255, 0.1);
    padding: 2px 8px;
    border-radius: 4px;
  }
`;

export const SettingsPanel = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  
  .settings-section {
    margin-bottom: 24px;
    
    h3 {
      font-size: 16px;
      font-weight: 600;
      color: ${COLORS.textDark};
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid ${COLORS.border};
    }
  }
  
  .settings-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
    
    &:last-child {
      border-bottom: none;
    }
    
    .settings-label {
      font-size: 14px;
      color: ${COLORS.textDark};
      
      .settings-description {
        font-size: 12px;
        color: ${COLORS.textLight};
        margin-top: 2px;
      }
    }
  }
`;

export const NewConversationButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  background: ${COLORS.$primaryBlue};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  transition: all 0.2s ease;
  
  &:hover {
    background: #0056b3;
  }
  
  &:disabled {
    background: ${COLORS.border};
    cursor: not-allowed;
  }
`;

export const PatientSearchList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid ${COLORS.border};
  border-radius: 8px;
  margin-top: 12px;
`;

export const PatientSearchItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid ${COLORS.border};
  transition: all 0.2s ease;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: #f5f5f5;
  }
  
  .patient-info {
    flex: 1;
    
    .patient-name {
      font-weight: 600;
      color: ${COLORS.textDark};
      font-size: 14px;
    }
    
    .patient-phone {
      font-size: 12px;
      color: ${COLORS.textLight};
      margin-top: 2px;
    }
  }
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 110px); /* Account for AdminLayout padding (30px) + PageHeader (~80px) */
  overflow: hidden;
  
  @media (max-width: 1024px) {
    height: calc(100vh - 125px); /* Account for mobile top bar + padding */
  }
`;

export const StyledTabs = styled(Tabs)`
  margin: 0 !important;
  background: transparent;
  padding-top: 16px;
  padding-bottom: 8px;
  margin-bottom: 0;
  
  .ant-tabs-nav {
    margin: 0 !important;
    
    &::before {
      display: none !important;
    }
  }
  
  /* Hide ink bar */
  .ant-tabs-ink-bar {
    display: none !important;
  }
  
  /* Make the tab strip horizontally scrollable on small widths */
  .ant-tabs-nav-wrap {
    overflow-x: auto;
    scrollbar-width: none; /* Firefox */
    
    &::-webkit-scrollbar {
      display: none; /* WebKit */
    }
  }
  
  .ant-tabs-nav-list {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
    width: auto;
    
    .ant-tabs-tab {
      position: relative;
      padding: 0;
      margin: 0;
      background: transparent;
      border: none;
      transition: all 0.2s ease;
      flex: none;
      width: auto;
      
      /* Remove dividers */
      &::before {
        display: none;
      }
      
      .ant-tabs-tab-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 14px;
        border-radius: 999px;
        color: ${COLORS.textMedium};
        font-weight: 500;
        font-size: 14px;
        transition: background-color .2s ease, color .2s ease;
        background: transparent;
        border: none;
        min-height: 40px;
        white-space: nowrap;
        
        .anticon {
          font-size: 16px;
        }
      }
      
      &:hover .ant-tabs-tab-btn {
        color: ${COLORS.textDark};
        background: rgba(24, 144, 255, 0.08);
      }
      
      &.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: ${COLORS.$primaryBlue};
        background: #eef4ff;
        font-weight: 600;
        box-shadow: 0 1px 3px rgba(0,0,0,.06);
        border: 1px solid rgba(24, 144, 255, 0.3);
      }
      
      /* Visible keyboard focus */
      .ant-tabs-tab-btn:focus-visible {
        outline: 2px solid ${COLORS.$primaryBlue};
        outline-offset: 2px;
        border-radius: 999px;
      }
    }
  }
  
  /* If header-only tabs (no inner tab panels) */
  .ant-tabs-content-holder {
    display: none;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .ant-tabs-nav-list {
      gap: 2px;
      
      .ant-tabs-tab {
        .ant-tabs-tab-btn {
          font-size: 13px;
          padding: 8px 12px;
          min-height: 36px;
          
          .anticon {
            font-size: 14px;
          }
        }
      }
    }
  }
  
  @media (max-width: 576px) {
    .ant-tabs-nav-list {
      .ant-tabs-tab {
        .ant-tabs-tab-btn {
          font-size: 12px;
          padding: 6px 10px;
          min-height: 32px;
        }
      }
    }
  }
`;

export const TabsBorderDiv = styled.div`
  height: 1px;
  background: ${COLORS.border};
  margin-bottom: 16px;
`;
